import easterTakeoverConfig from 'takeovers/easterTakeover/easterTakeoverConfig'
import lunarNewYearTakeoverConfig from 'takeovers/lunarNewYearTakeover/lunarNewYearTakeoverConfig'
import luxPlusMonthTakeoverConfig from 'takeovers/luxPlusMonthTakeover/luxPlusMonthTakeoverConfig'
import marchTravelFrenzyTakeoverConfig from 'takeovers/marchTravelFrenzyTakeover/marchTravelFrenzyTakeoverConfig'
import neverEndingSummerTakeoverConfig from 'takeovers/neverEndingSummerTakeover/neverEndingSummerTakeoverConfig'
import societyTriplePointsTakeoverConfig from 'takeovers/societyTriplePointsTakeover/societyTriplePointsTakeoverConfig'
import tourBestAsiaPromoTakeoverConfig from 'takeovers/tourBestAsiaPromoTakeover/tourBestAsiaPromoTakeoverConfig'
import valentineTakeoverConfig from 'takeovers/valentineTakeover/valentineTakeoverConfig'

export enum TakeoverId {
  LUNAR_NEW_YEAR_TAKEOVER = 'lunarNewYearTakeover',
  VALENTINE_TAKEOVER = 'valentineTakeover',
  MARCH_TRAVEL_FRENZY_TAKEOVER = 'marchTravelFrenzyTakeover',
  TOUR_BEST_ASIA_PROMO_TAKEOVER = 'tourBestAsiaPromoTakeover',
  EASTER_TAKEOVER = 'easterTakeover',
  SOCIETY_TRIPLE_POINTS_TAKEOVER = 'societyTriplePointsTakeover',
  NEVER_ENDING_SUMMER_TAKEOVER = 'neverEndingSummerTakeover',
  LUX_PLUS_MONTH_TAKEOVER = 'luxPlusMonthTakeover',
}

export const takeovers: Record<TakeoverId, App.SiteTakeoverConfig> = {
  [TakeoverId.LUNAR_NEW_YEAR_TAKEOVER]: lunarNewYearTakeoverConfig,
  [TakeoverId.VALENTINE_TAKEOVER]: valentineTakeoverConfig,
  [TakeoverId.MARCH_TRAVEL_FRENZY_TAKEOVER]: marchTravelFrenzyTakeoverConfig,
  [TakeoverId.TOUR_BEST_ASIA_PROMO_TAKEOVER]: tourBestAsiaPromoTakeoverConfig,
  [TakeoverId.EASTER_TAKEOVER]: easterTakeoverConfig,
  [TakeoverId.SOCIETY_TRIPLE_POINTS_TAKEOVER]: societyTriplePointsTakeoverConfig,
  [TakeoverId.NEVER_ENDING_SUMMER_TAKEOVER]: neverEndingSummerTakeoverConfig,
  [TakeoverId.LUX_PLUS_MONTH_TAKEOVER]: luxPlusMonthTakeoverConfig,
} as const
